// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

.markdown-preview {
  font-family: Arial, sans-serif;
  line-height: 1.6;
  color: #333;
}

.markdown-preview h1,
.markdown-preview h2,
.markdown-preview h3 {
  margin-top: 20px;
  margin-bottom: 10px;
  font-weight: bold;
}

.markdown-preview p {
  margin: 10px 0;
}

.markdown-preview ul {
  padding-left: 20px;
  list-style-type: disc;
  margin: 10px 0;
}

.markdown-preview li {
  margin-bottom: 5px;
}

.markdown-preview a {
  color: #0969da;
  text-decoration: underline;
}

.markdown-preview strong {
  font-weight: bold;
}

.markdown-preview em {
  font-style: italic;
}

.markdown-preview table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 1rem;
  font-size: 0.95rem;
}

.markdown-preview th,
.markdown-preview td {
  border: 1px solid #ccc;
  padding: 8px 12px;
  text-align: left;
  vertical-align: top;
}

.markdown-preview th {
  background-color: #f9f9f9;
  font-weight: bold;
}

.markdown-preview tr:nth-child(even) {
  background-color: #f6f8fa;
}

.markdown-preview a {
  color: #0366d6;
  text-decoration: underline;
  word-break: break-word;
}

.markdown-preview td {
  word-break: break-word;
  white-space: normal;
}

/* width */
::-webkit-scrollbar {
  width: 4px;
  scrollbar-width: thin;
}

/* Track */
::-webkit-scrollbar-track {
  background: transparent;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 20px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #888;
}

.gsi-material-button {
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -webkit-appearance: none;
  background-color: WHITE;
  background-image: none;
  border: 1px solid #747775;
  border-radius: 4px;
  box-sizing: border-box;
  color: #1f1f1f;
  cursor: pointer;
  font-family: 'Roboto', arial, sans-serif;
  font-size: 14px;
  height: 40px;
  letter-spacing: 0.25px;
  outline: none;
  overflow: hidden;
  padding: 0 12px;
  position: relative;
  text-align: center;
  transition: background-color .218s, border-color .218s, box-shadow .218s;
  vertical-align: middle;
  white-space: nowrap;
  width: auto;
  max-width: 400px;
  min-width: min-content;
}

.gsi-material-button .gsi-material-button-icon {
  height: 20px;
  margin-right: 12px;
  min-width: 20px;
  width: 20px;
}

.gsi-material-button .gsi-material-button-content-wrapper {
  align-items: center;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  height: 100%;
  justify-content: space-between;
  position: relative;
  width: 100%;
}

.gsi-material-button .gsi-material-button-contents {
  flex-grow: 1;
  font-family: 'Roboto', arial, sans-serif;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: top;
}

.gsi-material-button .gsi-material-button-state {
  transition: opacity .218s;
  bottom: 0;
  left: 0;
  opacity: 0;
  position: absolute;
  right: 0;
  top: 0;
}

.gsi-material-button:disabled {
  cursor: default;
  background-color: #ffffff61;
  border-color: #1f1f1f1f;
}

.gsi-material-button:disabled .gsi-material-button-contents {
  opacity: 38%;
}

.gsi-material-button:disabled .gsi-material-button-icon {
  opacity: 38%;
}

.gsi-material-button:not(:disabled):active .gsi-material-button-state,
.gsi-material-button:not(:disabled):focus .gsi-material-button-state {
  background-color: #303030;
  opacity: 12%;
}

.gsi-material-button:not(:disabled):hover {
  box-shadow: 0 1px 2px 0 rgba(60, 64, 67, .30), 0 1px 3px 1px rgba(60, 64, 67, .15);
}

.gsi-material-button:not(:disabled):hover .gsi-material-button-state {
  background-color: #303030;
  opacity: 8%;
}


@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

@media (max-width: 768px) {
  .markdown-preview table,
  .markdown-preview thead,
  .markdown-preview tbody,
  .markdown-preview th,
  .markdown-preview td,
  .markdown-preview tr {
    display: block;
    width: 100%;
  }

  .markdown-preview thead {
    display: none;
  }

  .markdown-preview tr {
    margin-bottom: 1rem;
    border: 1px solid #ccc;
    padding: 10px;
    border-radius: 8px;
    background-color: #f9f9f9;
  }

  .markdown-preview td {
    min-height: 38px;
    position: relative;
    padding-left: 50%;
    border: none;
    border-bottom: 1px solid #eee;
  }

  .markdown-preview td::before {
    content: attr(data-label);
    position: absolute;
    left: 8px;
    top: 8px;
    width: 45%;
    padding-right: 10px;
    font-weight: bold;
    white-space: nowrap;
  }
}

@media (min-width: 769px) {
  .markdown-preview {
    max-width: 46rem;
    overflow: hidden;
  }

  .markdown-preview table {
    width: 100%;
    margin: 0;
    border: 1px solid #e5e7eb;
    table-layout: auto;
  }

  .markdown-preview th,
  .markdown-preview td {
    white-space: normal;
    word-break: break-word;
  }

  .markdown-preview th {
    position: sticky;
    top: 0;
    background-color: #f9fafb;
  }

  .table-wrapper th,
  .table-wrapper td {
    white-space: normal;
    word-break: break-word;
  }
  
  .table-container {
    width: 100%;
    max-width: 100%;
    margin-top: 1rem;
    margin-bottom: 1rem;
    overflow: hidden;
  }

  .table-wrapper {
    overflow-x: auto;
    overflow-y: visible;
    border-radius: 8px;
    border: 1px solid #e5e7eb;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
    max-width: 100%;
    scrollbar-width: thin;
    scrollbar-color: rgba(0, 0, 0, 0.2) transparent;
  }

  .table-wrapper table {
    width: 100%;
    table-layout: auto;
    border-collapse: collapse;
    min-width: fit-content;
  }

  .table-wrapper th,
  .table-wrapper td {
    padding: 8px 12px;
    text-align: left;
    vertical-align: top;
    border: 1px solid #e5e7eb;
    word-break: break-word;
    white-space: normal;
  }

  .table-wrapper th {
    background-color: #f9fafb;
    font-weight: 600;
    position: sticky;
    top: 0;
  }

  .table-wrapper::-webkit-scrollbar {
    height: 4px;
    width: 4px;
  }

  .table-wrapper::-webkit-scrollbar-track {
    background: transparent;
  }

  .table-wrapper::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 2px;
  }

  .table-wrapper:hover::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.2);
  }

  .table-wrapper::-webkit-scrollbar-thumb:hover {
    background: rgba(0, 0, 0, 0.4);
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,WAAW;AACb;;AAEA;;;EAGE,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,UAAU;EACV,qBAAqB;AACvB;;AAEA,UAAU;AACV;EACE,uBAAuB;AACzB;;AAEA,WAAW;AACX;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;EACtB,yBAAyB;EAEzB,kBAAkB;EAElB,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,wCAAwC;EACxC,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAElB,wEAAwE;EACxE,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EAEE,mBAAmB;EACnB,aAAa;EAEb,mBAAmB;EAEnB,iBAAiB;EACjB,YAAY;EACZ,8BAA8B;EAC9B,kBAAkB;EAClB,WAAW;AACb;;AAEA;EAEE,YAAY;EACZ,wCAAwC;EACxC,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EAEE,yBAAyB;EACzB,SAAS;EACT,OAAO;EACP,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,MAAM;AACR;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EAEE,kFAAkF;AACpF;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;;AAGA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;;;;;;IAME,cAAc;IACd,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;IACb,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,6BAA6B;EAC/B;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,UAAU;IACV,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,SAAS;IACT,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;;IAEE,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,MAAM;IACN,yBAAyB;EAC3B;;EAEA;;IAEE,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,0CAA0C;IAC1C,eAAe;IACf,qBAAqB;IACrB,+CAA+C;EACjD;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,sBAAsB;EACxB;;EAEA;;IAEE,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;IAChB,MAAM;EACR;;EAEA;IACE,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;EAChC;AACF","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n.markdown-preview {\n  font-family: Arial, sans-serif;\n  line-height: 1.6;\n  color: #333;\n}\n\n.markdown-preview h1,\n.markdown-preview h2,\n.markdown-preview h3 {\n  margin-top: 20px;\n  margin-bottom: 10px;\n  font-weight: bold;\n}\n\n.markdown-preview p {\n  margin: 10px 0;\n}\n\n.markdown-preview ul {\n  padding-left: 20px;\n  list-style-type: disc;\n  margin: 10px 0;\n}\n\n.markdown-preview li {\n  margin-bottom: 5px;\n}\n\n.markdown-preview a {\n  color: #0969da;\n  text-decoration: underline;\n}\n\n.markdown-preview strong {\n  font-weight: bold;\n}\n\n.markdown-preview em {\n  font-style: italic;\n}\n\n.markdown-preview table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 1rem;\n  font-size: 0.95rem;\n}\n\n.markdown-preview th,\n.markdown-preview td {\n  border: 1px solid #ccc;\n  padding: 8px 12px;\n  text-align: left;\n  vertical-align: top;\n}\n\n.markdown-preview th {\n  background-color: #f9f9f9;\n  font-weight: bold;\n}\n\n.markdown-preview tr:nth-child(even) {\n  background-color: #f6f8fa;\n}\n\n.markdown-preview a {\n  color: #0366d6;\n  text-decoration: underline;\n  word-break: break-word;\n}\n\n.markdown-preview td {\n  word-break: break-word;\n  white-space: normal;\n}\n\n/* width */\n::-webkit-scrollbar {\n  width: 4px;\n  scrollbar-width: thin;\n}\n\n/* Track */\n::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n/* Handle */\n::-webkit-scrollbar-thumb {\n  background: rgba(0, 0, 0, 0.2);\n  border-radius: 20px;\n}\n\n/* Handle on hover */\n::-webkit-scrollbar-thumb:hover {\n  background: #888;\n}\n\n.gsi-material-button {\n  -moz-user-select: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  -webkit-appearance: none;\n  background-color: WHITE;\n  background-image: none;\n  border: 1px solid #747775;\n  -webkit-border-radius: 4px;\n  border-radius: 4px;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  color: #1f1f1f;\n  cursor: pointer;\n  font-family: 'Roboto', arial, sans-serif;\n  font-size: 14px;\n  height: 40px;\n  letter-spacing: 0.25px;\n  outline: none;\n  overflow: hidden;\n  padding: 0 12px;\n  position: relative;\n  text-align: center;\n  -webkit-transition: background-color .218s, border-color .218s, box-shadow .218s;\n  transition: background-color .218s, border-color .218s, box-shadow .218s;\n  vertical-align: middle;\n  white-space: nowrap;\n  width: auto;\n  max-width: 400px;\n  min-width: min-content;\n}\n\n.gsi-material-button .gsi-material-button-icon {\n  height: 20px;\n  margin-right: 12px;\n  min-width: 20px;\n  width: 20px;\n}\n\n.gsi-material-button .gsi-material-button-content-wrapper {\n  -webkit-align-items: center;\n  align-items: center;\n  display: flex;\n  -webkit-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  height: 100%;\n  justify-content: space-between;\n  position: relative;\n  width: 100%;\n}\n\n.gsi-material-button .gsi-material-button-contents {\n  -webkit-flex-grow: 1;\n  flex-grow: 1;\n  font-family: 'Roboto', arial, sans-serif;\n  font-weight: 500;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  vertical-align: top;\n}\n\n.gsi-material-button .gsi-material-button-state {\n  -webkit-transition: opacity .218s;\n  transition: opacity .218s;\n  bottom: 0;\n  left: 0;\n  opacity: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.gsi-material-button:disabled {\n  cursor: default;\n  background-color: #ffffff61;\n  border-color: #1f1f1f1f;\n}\n\n.gsi-material-button:disabled .gsi-material-button-contents {\n  opacity: 38%;\n}\n\n.gsi-material-button:disabled .gsi-material-button-icon {\n  opacity: 38%;\n}\n\n.gsi-material-button:not(:disabled):active .gsi-material-button-state,\n.gsi-material-button:not(:disabled):focus .gsi-material-button-state {\n  background-color: #303030;\n  opacity: 12%;\n}\n\n.gsi-material-button:not(:disabled):hover {\n  -webkit-box-shadow: 0 1px 2px 0 rgba(60, 64, 67, .30), 0 1px 3px 1px rgba(60, 64, 67, .15);\n  box-shadow: 0 1px 2px 0 rgba(60, 64, 67, .30), 0 1px 3px 1px rgba(60, 64, 67, .15);\n}\n\n.gsi-material-button:not(:disabled):hover .gsi-material-button-state {\n  background-color: #303030;\n  opacity: 8%;\n}\n\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@media (max-width: 768px) {\n  .markdown-preview table,\n  .markdown-preview thead,\n  .markdown-preview tbody,\n  .markdown-preview th,\n  .markdown-preview td,\n  .markdown-preview tr {\n    display: block;\n    width: 100%;\n  }\n\n  .markdown-preview thead {\n    display: none;\n  }\n\n  .markdown-preview tr {\n    margin-bottom: 1rem;\n    border: 1px solid #ccc;\n    padding: 10px;\n    border-radius: 8px;\n    background-color: #f9f9f9;\n  }\n\n  .markdown-preview td {\n    min-height: 38px;\n    position: relative;\n    padding-left: 50%;\n    border: none;\n    border-bottom: 1px solid #eee;\n  }\n\n  .markdown-preview td::before {\n    content: attr(data-label);\n    position: absolute;\n    left: 8px;\n    top: 8px;\n    width: 45%;\n    padding-right: 10px;\n    font-weight: bold;\n    white-space: nowrap;\n  }\n}\n\n@media (min-width: 769px) {\n  .markdown-preview {\n    max-width: 46rem;\n    overflow: hidden;\n  }\n\n  .markdown-preview table {\n    width: 100%;\n    margin: 0;\n    border: 1px solid #e5e7eb;\n    table-layout: auto;\n  }\n\n  .markdown-preview th,\n  .markdown-preview td {\n    white-space: normal;\n    word-break: break-word;\n  }\n\n  .markdown-preview th {\n    position: sticky;\n    top: 0;\n    background-color: #f9fafb;\n  }\n\n  .table-wrapper th,\n  .table-wrapper td {\n    white-space: normal;\n    word-break: break-word;\n  }\n  \n  .table-container {\n    width: 100%;\n    max-width: 100%;\n    margin-top: 1rem;\n    margin-bottom: 1rem;\n    overflow: hidden;\n  }\n\n  .table-wrapper {\n    overflow-x: auto;\n    overflow-y: visible;\n    border-radius: 8px;\n    border: 1px solid #e5e7eb;\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);\n    max-width: 100%;\n    scrollbar-width: thin;\n    scrollbar-color: rgba(0, 0, 0, 0.2) transparent;\n  }\n\n  .table-wrapper table {\n    width: 100%;\n    table-layout: auto;\n    border-collapse: collapse;\n    min-width: fit-content;\n  }\n\n  .table-wrapper th,\n  .table-wrapper td {\n    padding: 8px 12px;\n    text-align: left;\n    vertical-align: top;\n    border: 1px solid #e5e7eb;\n    word-break: break-word;\n    white-space: normal;\n  }\n\n  .table-wrapper th {\n    background-color: #f9fafb;\n    font-weight: 600;\n    position: sticky;\n    top: 0;\n  }\n\n  .table-wrapper::-webkit-scrollbar {\n    height: 4px;\n    width: 4px;\n  }\n\n  .table-wrapper::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  .table-wrapper::-webkit-scrollbar-thumb {\n    background: transparent;\n    border-radius: 2px;\n  }\n\n  .table-wrapper:hover::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n  }\n\n  .table-wrapper::-webkit-scrollbar-thumb:hover {\n    background: rgba(0, 0, 0, 0.4);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
